// src/firebase.js
// ⚠️  GANTI DENGAN KONFIGURASI FIREBASE KAMU
// Cara mendapatkan: Firebase Console → Project Settings → Your Apps → Web App

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCMeFz-O1i6YGvSvND8EWOMI61UJ9FspQU",
  authDomain: "qurma-2026.firebaseapp.com",
  projectId: "qurma-2026",
  storageBucket: "qurma-2026.firebasestorage.app",
  messagingSenderId: "689193093732",
  appId: "1:689193093732:web:ae59bd70b5ac62a34fad71"
};

// App utama — untuk login admin & kurir yang sedang aktif
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// App sekunder — dipakai HANYA untuk membuat akun kurir baru dari admin
// supaya sesi admin tidak ter-logout saat mendaftarkan kurir
export const secondaryApp = initializeApp(firebaseConfig, 'secondary');
export const secondaryAuth = getAuth(secondaryApp);

export default app;
